import { PsHttpService, type PatSnapCommonResponseData } from '@patsnap/tahiti-core/common/ps-http';
import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import { FactoryPsHttpSSE } from '@patsnap-utils/sse';
import type { ReverseEngineeringApi } from '../re-api';
import type {
  ChatInput,
  ChatResponse,
} from '@/components/pages/reverse-engineering/types/message.types';
import type {
  SearchResultRequest,
  SearchResultResponse,
} from '@/components/pages/reverse-engineering/types/search.types';

@injectable()
export class ReverseEngineeringApiImpl extends PsHttpService implements ReverseEngineeringApi {
  @inject(FactoryPsHttpSSE)
  private _factorySsePsHttp!: FactoryPsHttpSSE;

  private isLocal = import.meta.env.DEV;
  private domain = this.isLocal ? 'http://localhost:8000' : import.meta.env.VITE_EUREKA_SERVICE_URI;
  private headers = {
    'X-API-Version': '1.0',
    ...(this.isLocal && { 'X-User-Id': 'Local-User-Dev' }),
  };

  get options() {
    return {
      baseURL: `${this.domain}/api/mse-ci`,
      headers: this.headers,
    };
  }

  chat(input: ChatInput): Promise<ChatResponse> {
    return this.post<PatSnapCommonResponseData<ChatResponse>>({
      baseURL: this.options.baseURL,
      url: '/agent/chat',
      data: input,
    }).then((res) => {
      return res.data as ChatResponse;
    });
  }

  connect(conversation_id: string) {
    return this._factorySsePsHttp<Record<any, any>>()
      .init({
        method: 'GET',
        url: `${this.options.baseURL}/agent/connect/${conversation_id}`,
        hasFinalMessage: () => true,
      })
      .setFetchHeaders(this.headers);
  }

  getSearchResult(input: SearchResultRequest): Promise<SearchResultResponse> {
    return this.post<PatSnapCommonResponseData<SearchResultResponse>>({
      baseURL: this.options.baseURL,
      url: '/agent/re/search-result',
      data: input,
    }).then((res) => {
      return res.data as SearchResultResponse;
    });
  }

  getProcesses(input: Record<any, any>): Promise<Record<any, any>> {
    return this.post<PatSnapCommonResponseData<SearchResultResponse>>({
      baseURL: this.options.baseURL,
      url: '/agent/re/process-comparison',
      data: input,
    }).then((res) => {
      return res.data;
    });
  }
}
